import {createCssVar} from '../theme'
import {css} from '../theme/css'

export const [offset, setOffset] = createCssVar('divider-offset', '0px')

export const classes = {
  dividerOffset: css`
    &:before {
      inset-inline: ${offset} !important;
    }
  `,
}
